import dayjs from 'dayjs';
import { ICustomersGetResponse, ICustomersUserProfileResponse } from '../endpoints/customers';
import { InvoicesStateEnum } from '../types/enums';
import { IDeliveryItem, IPendingPrescription } from '../types/interfaces';
import { ITransferPrescriptions } from '../types/interfaces/transfer-prescriptions';
import { ICustomerRequestItem } from '@/shared/types/interfaces/customer-requests';


export interface IPrescribables {
    includingMedbox: ITransferPrescriptions[];
    packagedSeparately: ITransferPrescriptions[];
}

export const validInvoicesForCustomerViewing = [
    InvoicesStateEnum.OPEN,
    InvoicesStateEnum.AUTHORIZED,
    InvoicesStateEnum.UNPAID,
    InvoicesStateEnum.DONE
];
export const paidStates = [InvoicesStateEnum.DONE, InvoicesStateEnum.AUTHORIZED];
export const unpaidStates = [InvoicesStateEnum.OPEN, InvoicesStateEnum.UNPAID];
export const isInvoiceValid = (state: InvoicesStateEnum) => validInvoicesForCustomerViewing.includes(state);
export const isInvoicePaid = (state: InvoicesStateEnum) => paidStates.includes(state);
export const isInvoiceUnpaid = (state: InvoicesStateEnum) => unpaidStates.includes(state);
export const getInvoiceNumber = (invoiceNumber: string) => {
    const match = invoiceNumber?.match(/QFE:\/\/(.*)/);
    return match ? match[1] : '';
};

export const convertedMedications = (user?: ICustomersGetResponse): IPrescribables => {
    const data: IPrescribables = {
        includingMedbox: [],
        packagedSeparately: []
    };
    user!.transferPrescriptions.forEach(e => {
        if (e.packaging === 'Include in my MedBox' || !e.packaging) data.includingMedbox.push(e);
        if (e.packaging === 'Package separately') data.packagedSeparately.push(e);
    });
    return data;
};

export const getUserFullName = (user: ICustomersGetResponse) => `${user.userProfile.firstName} ${user.userProfile.lastName}`;

export const isPendingPrescription = (
    prescription:
        | (ICustomerRequestItem & { details: { prescribable: ITransferPrescriptions } })
        | ITransferPrescriptions
        | IPendingPrescription
): prescription is IPendingPrescription => {
    return (prescription as IPendingPrescription).handled !== undefined;
};

export const isDeliveryItem = (
    prescription: IPendingPrescription | IDeliveryItem | ITransferPrescriptions
): prescription is IDeliveryItem => {
    return (prescription as IDeliveryItem).fill !== undefined;
};

export const checkHasPregnancy = (userProfile: ICustomersUserProfileResponse) => {
    if (!userProfile || !userProfile.dob || !userProfile.gender) {
        return false;
    }

    if (userProfile.gender !== 'F') {
        return false;
    }
    const birthDate = dayjs(userProfile.dob);
    if (birthDate.add(55, 'years').isBefore(dayjs())) {
        return false;
    }
    return true;
};

export const allUnhandledPendingPrescriptions = (patPendingPrescriptions: IPendingPrescription[] | null) =>
    (patPendingPrescriptions || []).filter(pendingRx => !pendingRx.handled);